import moment from "moment"
import { MarginCalculationType_Fixed, MarginCalculationType_RealPayRatio, MarginCalculationType_BaseSalaryRatio } from "./ItemCustomerPosition"
import { ReqRecruitmentItem_SalaryBase } from "./ItemContractorAttendance_RecruitmentItem_SalaryBase"
import { DailyWageMonthly_Real, DailyWageMonthly_Fixed } from "./ItemContractorAttendance"

export class ReqRecruitmentItem_SalaryMonthly extends ReqRecruitmentItem_SalaryBase {
    /*

        Name,           //姓名
        Job,            //職務
        BaseSalary,     //底薪
        AttendanceDay,  //出勤天數
        OvertimePay,    //加班
        AbsenceAmout,   //請假
        SalaryAddAmount,    //加項
        SalarySubtractAmount,   //減項
        Salary,         //應付薪資
        PreServiceFee,  //服務費-未扣保費
    */
    constructor({ Recruitment, caseInfo, PositionInfo, startDate, endDate }) {
        super({Recruitment, caseInfo, PositionInfo, startDate, endDate})
        if(PositionInfo === undefined)
        return
        this.OvertimePay = 0                                            //加班
        this.setDate()
        this.setDailyWageMonthly(DailyWageMonthly_Fixed)
        this.Salary = 0                                                 //應付薪資
        this.PreServiceFee = 0                                          //服務費-未扣保費
        this.setSalary()
    }

    fromJson(jsonData) {
        super.fromJson(jsonData)
        this.OvertimePay = jsonData.OvertimePay                              //減項金額
        this.setDate()
        // this.setSalary()
    }

    //設定加班金額
    setOvertimePay(OvertimePay) {
        this.OvertimePay = OvertimePay
    }

    //計算應付
    setSalary() {
        this.Salary = this.MonthlySalary + this.OvertimePay - this.AbsenceAmout + this.SalaryAddAmount - this.SalarySubtractAmount
        console.log(this.PositionInfo)
        if (this.PositionInfo === undefined)
            return
        var MonthlySalaryAmount = this.PositionInfo.wageInfo.MonthlySalaryAmount
        switch (parseInt(this.PositionInfo.wageInfo.MarginCalculationType)) {
            case MarginCalculationType_Fixed:
                MonthlySalaryAmount = this.PositionInfo.wageInfo.MonthlySalaryAmount
                this.PreServiceFee = MonthlySalaryAmount * this.AttendanceRatio
                break;
            case MarginCalculationType_BaseSalaryRatio:
                MonthlySalaryAmount = this.PositionInfo.wageInfo.MonthlySalaryAmount / 100
                this.PreServiceFee = Math.round(this.BaseSalary * MonthlySalaryAmount * this.AttendanceRatio)
                break;
            case MarginCalculationType_RealPayRatio:
                MonthlySalaryAmount = this.PositionInfo.wageInfo.MonthlySalaryAmount / 100
                this.PreServiceFee = Math.round(this.Salary * MonthlySalaryAmount)
                break;
            default:
                break;
        }
    }

    setDailyWageMonthly(DailyWageMonthly) {
        // console.log(DailyWageMonthly)
        switch (DailyWageMonthly) {
            case DailyWageMonthly_Real:
                // console.log(this.sDay)
                // console.log(moment(this.sDay).daysInMonth())
                this.DailyWageMonthly = moment(this.sDay).daysInMonth();
                break;
            default:
                this.DailyWageMonthly = 30
                break;
        }
        // console.log(this.DailyWageMonthly)
        this.hourlySalary = this.BaseSalary / this.AttendanceDay / 8  //時薪
        this.AttendanceRatio = 1
        if (this.AttendanceDay < this.DailyWageMonthly) {
            this.AttendanceRatio = this.AttendanceDay / this.DailyWageMonthly   //出勤比率
        }

        console.log(this.AttendanceRatio)
        console.log(this.BaseSalary)
        this.MonthlySalary = Math.round(this.BaseSalary * this.AttendanceRatio) //窴際月薪
        console.log(this.MonthlySalary)
        this.setSalary()
    }
}
